/* LIVADUR — geteilte Animations-Helfer
   ----------------------------------------------------------------------------
   1:1-Port der beiden Helfer aus dem Head-Skript der Webflow-Seite:

     odo(el, value)             Ziffernrollwerk
     stagger(el, text, mode)    gestaffelter Zeichen-/Wortwechsel

   Beide werden von mehreren Sections gebraucht (Bedarfsrechner, Jahreskurve,
   Wirkungskette) und liegen deshalb hier statt in einer Section.

   Form von window.LVD bleibt unveraendert: { odo, stagger, reduce, hasSplit } —
   die Sections programmieren unveraendert dagegen.

   Unterschied zum Original: dort lief alles in einem DOMContentLoaded-Handler.
   Hier wird window.LVD schon beim Ausfuehren der Datei gesetzt (die Datei wird
   per defer eingebunden, laeuft also garantiert VOR DOMContentLoaded). Die
   Sections finden LVD damit in ihrem eigenen DOMContentLoaded-Handler vor.

   SplitText ist im Theme NICHT geladen (DSGVO, kein GSAP-Bonus-Plugin) —
   hasSplit ist deshalb im Normalfall false und der eigene Splitter (ownSplit)
   ist der Regelweg. Der SplitText-Zweig bleibt 1:1 erhalten, falls das Plugin
   irgendwann doch dazukommt.

   Das zugehoerige CSS bringt snippets/DTA-anim-helpers.liquid mit.
   -------------------------------------------------------------------------- */
(function () {
  /* Mehrfach eingebunden (mehrere Sections auf einer Seite) -> nur einmal ausfuehren. */
  if (window.LVD && window.LVD.odo && window.LVD.stagger) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasSplit = !!(window.gsap && window.SplitText);
  if (hasSplit) {
    try {
      gsap.registerPlugin(SplitText);
    } catch (e) {
      hasSplit = false;
    }
  }

  /* Ziffernrollwerk: positionsbasiert statt Animation pro Aenderung, damit es dem
     Regler folgt statt gegen ihn zu arbeiten. Transition, nicht Keyframes. */
  function odo(el, value) {
    var s = String(value);
    if (el._odoLen !== s.length) {
      el._odoLen = s.length;
      el.innerHTML = '';
      var wrap = document.createElement('span');
      wrap.className = 'odo';
      for (var i = 0; i < s.length; i++) {
        var col = document.createElement('span');
        col.className = 'odo-col';
        var strip = document.createElement('span');
        strip.className = 'odo-strip';
        for (var d = 0; d < 10; d++) {
          var x = document.createElement('span');
          x.textContent = d;
          strip.appendChild(x);
        }
        col.appendChild(strip);
        wrap.appendChild(col);
      }
      el.appendChild(wrap);
      el._strips = wrap.querySelectorAll('.odo-strip');
    }
    for (var k = 0; k < s.length; k++) {
      el._strips[k].style.transform = 'translateY(' + (-(+s[k]) * 10) + '%)';
    }
  }

  /* Gestaffelter Zeichenwechsel. Nutzt GSAP SplitText, falls vorhanden; ohne das
     Plugin faellt es auf einen eigenen Splitter zurueck. Ob gestaffelt oder hart
     getauscht wird, entscheidet der zeitliche Abstand zweier Wechsel, nicht die
     Geschwindigkeit: sonst laeuft der Stagger beim Hovern nie. */
  function ownSplit(el, text, mode) {
    var units = mode === 'words' ? text.split(/(\s+)/) : text.split('');
    el.innerHTML = '';
    var frag = document.createDocumentFragment(),
      spans = [];
    units.forEach(function (u) {
      var s = document.createElement('span');
      s.className = 'ch';
      s.textContent = u;
      frag.appendChild(s);
      spans.push(s);
    });
    el.appendChild(frag);
    return spans;
  }

  function pieces(el, text, mode) {
    if (!hasSplit) return ownSplit(el, text, mode);
    /* Reihenfolge ist hier entscheidend: SplitText.revert() schreibt den Text
       zurueck, der beim Aufteilen vorlag. Stand das Setzen des neuen Textes
       davor, hat revert() ihn sofort wieder ueberschrieben - der Wert blieb
       stehen. Genau das war die haengende Nabe ("Haut") und der Monat, der sich
       beim langsamen Wechsel nicht aenderte: bei schnellen Wechseln greift der
       harte Tausch weiter unten, deshalb trat es nur manchmal auf. */
    if (el._sp) {
      try {
        el._sp.revert();
      } catch (e) {}
      el._sp = null;
    }
    el.textContent = text;
    try {
      el._sp = new SplitText(el, {
        type: mode,
        aria: 'auto'
      });
    } catch (e) {
      el._sp = null;
      return ownSplit(el, text, mode);
    }
    return mode === 'words' ? el._sp.words : el._sp.chars;
  }

  function stagger(el, text, mode) {
    var now = performance.now();
    var fast = el._last && (now - el._last) < 380;
    el._last = now;
    if (el._tw) {
      el._tw.kill();
      el._tw = null;
    }
    if (el._t) {
      clearTimeout(el._t);
      el._t = null;
    }
    if (reduce || fast) {
      if (el._sp) {
        try {
          el._sp.revert();
        } catch (e) {}
        el._sp = null;
      }
      el.textContent = text;
      return;
    }
    var step = mode === 'words' ? 26 : 14;

    function enter() {
      var sp = pieces(el, text, mode);
      if (!sp || !sp.length) return;
      if (hasSplit && el._sp) {
        gsap.set(sp, {
          yPercent: 55,
          opacity: 0
        });
        el._tw = gsap.to(sp, {
          yPercent: 0,
          opacity: 1,
          duration: .3,
          ease: 'power3.out',
          stagger: step / 1000
        });
      } else {
        sp.forEach(function (s, i) {
          s.style.transition = 'none';
          s.style.opacity = 0;
          s.style.transform = 'translateY(55%)';
          requestAnimationFrame(function () {
            s.style.transition = 'opacity 300ms cubic-bezier(.23,1,.32,1) ' + (i * step) + 'ms, transform 300ms cubic-bezier(.23,1,.32,1) ' + (i * step) + 'ms';
            s.style.opacity = 1;
            s.style.transform = 'translateY(0)';
          });
        });
      }
    }
    var out = (hasSplit && el._sp) ? (mode === 'words' ? el._sp.words : el._sp.chars) : [].slice.call(el.querySelectorAll('.ch'));
    if (!out || !out.length) {
      enter();
      return;
    }
    if (hasSplit && el._sp) {
      el._tw = gsap.to(out, {
        yPercent: -55,
        opacity: 0,
        duration: .15,
        ease: 'power2.in',
        stagger: step * .7 / 1000,
        onComplete: enter
      });
    } else {
      out.forEach(function (s, i) {
        s.style.transition = 'opacity 150ms ease-out ' + (i * step * .7) + 'ms, transform 150ms ease-out ' + (i * step * .7) + 'ms';
        s.style.opacity = 0;
        s.style.transform = 'translateY(-55%)';
      });
      el._t = setTimeout(enter, 150 + out.length * step * .7);
    }
  }

  /* Fuer die Sections (Bedarfsrechner, Jahreskurve, Wirkungskette). */
  window.LVD = {
    odo: odo,
    stagger: stagger,
    reduce: reduce,
    hasSplit: hasSplit
  };
})();
